import styled from "styled-components";

const Error = styled.div`
  font-size: 14px;
  color: red;
  padding: 10px 0 0 0;
`;

export default Error;
